import React, { useEffect, useState } from 'react';
import './MaintenancePage.css';

const constructionGifs = [
  './imgs/jacking.gif',
  './imgs/coning.gif',
  './imgs/hammer.gif',
];

function MaintenancePage() {
  const [randomGif, setRandomGif] = useState('');

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * constructionGifs.length);
    setRandomGif(constructionGifs[randomIndex]);
  }, []);

  return (
    <div className="App">
      <div className="banner">
        <img src="./imgs/2.gif" alt="Top Banner" className="banner-gif" />
      </div>
      <div className="construction-container">
        <div className="header-section">
          <h1 data-text="UNDER CONSTRUCTION">UNDER CONSTRUCTION</h1>
          <p>bryanintindola.com</p>
        </div>
        <div className="gif-container">
          {randomGif && (
            <img
              src={randomGif}
              alt="Under Construction"
              className="construction-gif"
            />
          )}
        </div>
      </div>
      <div className="banner">
        <img src="./imgs/2.gif" alt="Bottom Banner" className="banner-gif" />
      </div>
    </div>
  );
}

export default MaintenancePage;